export const rfxEndpoints = {
  getRfxDetail: { method: 'get', path: '/{rfxId}' },
  getFormResponses: { method: 'get', path: '/request-form-template/{requestFormTemplateId}/responses' },
  getScoringTaskDetails: { method: 'get', path: '/tasks/{taskId}/responses-and-scores' },
  createRfxSupplier: { method: 'post', path: '/{rfxId}/rfx-supplier' },
  deleteRfxSupplier: { method: 'post', path: '/{rfxId}/rfx-supplier/{rfxSupplierId}' },
  sendQuestionnaire: { method: 'post', path: '/{rfxId}/send-questionnaire' },
  sendAdditionalQuestionnaire: { method: 'post', path: '/{rfxId}/send-additional-questionnaire' },
  listRfxSuppliers: { method: 'get', path: '/{rfxId}/rfx-suppliers' },
  scoreQuestionAnswer: { method: 'post', path: '/scores/{requestFormSubmissionId}' },
  updateRfxSupplierContact: { method: 'post', path: '/rfx-supplier-contact/{rfxSupplierId}' },
  createRequestFormTemplate: { method: 'post', path: '/{rfxId}/request-form-template/create' },
  deleteRequestFormTemplate: { method: 'post', path: '/{rfxId}/request-form-template/{requestFormTemplateId}/delete' },
  createRequestFormTemplatesFromExistingIds: { method: 'post', path: '/{rfxId}/request-form-templates/create-from-existing' },
  updateRequestFormTemplate: { method: 'post', path: '/request-form-template/{requestFormTemplateId}/update' },
  promoteRequestFormTemplate: { method: 'post', path: '/request-form-template/{requestFormTemplateId}/promote' },
  listRequestFormTemplatesByRfx: { method: 'get', path: '/{rfxId}/request-form-templates' },
  getRequestFormTemplate: { method: 'get', path: '/request-form-template/{requestFormTemplateId}' },
  updateRfxRequestFormTemplatesRanks: { method: 'post', path: '/{rfxId}/rfx-request-form-templates-ranks/update' },
  getOverallSupplierResults: { method: 'get', path: '/{rfxId}/results' },
  listRfxOwners: { method: 'get', path: '/{rfxId}/rfx-owners' },
  updateRfxOwners: { method: 'post', path: '/{rfxId}/rfx-owners' },
  getSuppliersFormsResults: { method: 'get', path: '/{rfxId}/results/forms' },
  getSuppliersFormPagesResults: { method: 'get', path: '/{rfxId}/results/forms/pages' },
  updateRfxRequestFormTemplateReviewers: {
    method: 'post',
    path: '/{rfxId}/request-form-template/{requestFormTemplateId}/reviewers',
  },
  updateRfxRequestFormTemplateWeighting: {
    method: 'post',
    path: '/{rfxId}/request-form-template/{requestFormTemplateId}/weighting',
  },
  getSuppliersQuestionsResults: {
    method: 'get',
    path: '/{rfxId}/results/request-form-template/{requestFormTemplateId}/questions',
  },
  updateRfxState: { method: 'post', path: '/{rfxId}/update-state' },
  getScoringProgress: { method: 'get', path: '/{rfxId}/scoring-progress' },
  getRfxAiScoringStatus: { method: 'get', path: '/{rfxId}/ai-scoring-status' },
  getRfxPricingAnalysisStatus: { method: 'get', path: '/{rfxId}/pricing-analysis/{formTemplateId}/status' },
  askRfxPricingAnalysisQuestion: { method: 'post', path: '/{rfxId}/pricing-analysis/{formTemplateId}/ask' },
  getRfxPricingAnalysisResults: { method: 'get', path: '/{rfxId}/pricing-analysis/{formTemplateId}/results' },
  getRfxPricingAnalysisQuestion: { method: 'get', path: '/{rfxId}/pricing-analysis/question/{questionId}' },
  getRfxPricingSupplierDocuments: { method: 'get', path: '/{rfxId}/pricing-analysis/{formTemplateId}/supplier-documents' },
  generateRfxFormTemplateInsights: { method: 'post', path: '/{rfxId}/form-template-insights/generate' },
  getRfxFormTemplateInsightsStatus: { method: 'get', path: '/{rfxId}/form-template-insights/status' },
  dismissRfxFormTemplateInsight: { method: 'post', path: '/{rfxId}/form-template-insights/{insightId}/dismiss' },
  listRfxFormTemplateInsights: { method: 'get', path: '/{rfxId}/form-template-insights' },
  updateRfxSupplierInstructions: { method: 'post', path: '/{rfxId}/supplier-instructions/update' },
  getRfxSupplierInstructions: { method: 'get', path: '/supplier-instructions/{requestId}' },
  getMyRfxs: { method: 'get', path: '/' },
  getRequestRfxRounds: { method: 'get', path: '/request-rfx/{requestId}/rounds' },
  getSupplierRfxRounds: { method: 'get', path: '/supplier-rfx-rounds/{requestId}' },
  getRfxConfidentialityAgreement: { method: 'get', path: '/rfx-confidentiality-agreement/{rfxId}/{rfxSupplierId}' },
  setRfxSupplierStatus: { method: 'post', path: '/{rfxId}/rfx-supplier/{rfxSupplierId}/set-status' },
  resendRfxSupplierInvitation: { method: 'post', path: '/{rfxId}/rfx-supplier/{rfxSupplierId}/resend-invitation' },
  ownerSetRfxSupplierStatus: { method: 'post', path: '/{rfxId}/rfx-supplier/{rfxSupplierId}/owner-set-status' },
  signRfxConfidentialityAgreement: { method: 'post', path: '/{rfxId}/rfx-confidentiality-agreement/{rfxSupplierId}/sign' },
  getUserRfxSupplier: { method: 'get', path: '/user-rfx-supplier/{requestId}' },
  trackUserRfxSupplierViewed: { method: 'post', path: '/user-rfx-supplier/{rfxSupplierId}/viewed' },
  getRfxSupplier: { method: 'get', path: '/rfx-org-supplier/{rfxId}/{orgSupplierId}' },
  rfxAiQuestionScoringFeedback: { method: 'post', path: '/ai-question-scoring/feedback' },
  rfxAiInsightsFeedback: { method: 'post', path: '/ai-insights/feedback' },
  rfxFormTemplateInsightsFeedback: { method: 'post', path: '/form-template-insights/feedback' },
  updateRfxSettings: { method: 'post', path: '/{rfxId}/settings' },
  aiScoreFill: { method: 'post', path: '/tasks/{taskId}/ai-score-fill' },
  listRfxDeadlines: { method: 'get', path: '/{rfxId}/deadlines' },
  createRfxDeadline: { method: 'post', path: '/{rfxId}/deadlines' },
  updateRfxDeadline: { method: 'post', path: '/{rfxId}/deadlines/{deadlineGroupId}' },
  deleteRfxDeadline: { method: 'post', path: '/{rfxId}/deadlines/{deadlineGroupId}/delete' },
  getRfxSupplierRecommendations: { method: 'get', path: '/{rfxId}/supplier-recommendations' },
  listRfxSupplierDeadlines: { method: 'get', path: '/{rfxId}/supplier-deadlines' },
  rfxSupplierRecommendationFeedback: { method: 'post', path: '/supplier-recommendations/feedback' },
  exportRfxResponses: { method: 'post', path: '/{rfxId}/export-responses' },
  generateRfxExecutiveSummary: { method: 'post', path: '/{rfxId}/executive-summary' },
  generateRfxSupplierEmail: { method: 'post', path: '/{rfxId}/generate-supplier-email' },
  getRfxSupplierNotification: { method: 'get', path: '/{rfxId}/supplier-notification' },
  exportRfxSupplierFiles: { method: 'post', path: '/{rfxId}/export-supplier-files' },
  getRfxQnaSession: { method: 'get', path: '/{rfxId}/qna/session' },
  getRfxSupplierQnaSession: { method: 'get', path: '/{rfxId}/{rfxSupplierId}/qna/session' },
  updateQnaStatus: { method: 'post', path: '/{rfxId}/qna/status' },
  submitQnaQuestions: { method: 'post', path: '/{rfxId}/qna/questions' },
  submitQnaQuestionsSupplier: { method: 'post', path: '/{rfxId}/{rfxSupplierId}/qna/questions' },
  listPublishedQnaItems: { method: 'post', path: '/{rfxId}/{rfxSupplierId}/qna/published' },
  listMyQnaItems: { method: 'get', path: '/{rfxId}/{rfxSupplierId}/qna/my-items' },
  listQnaItems: { method: 'post', path: '/{rfxId}/qna/items' },
  getQnaDetail: { method: 'get', path: '/{rfxId}/qna/items/{qnaItemId}' },
  saveQnaAnswer: { method: 'post', path: '/{rfxId}/qna/items/{qnaItemId}/answer' },
  updateQnaItemsStatus: { method: 'post', path: '/{rfxId}/qna/items/status' },
  groupQnaItems: { method: 'post', path: '/{rfxId}/qna/items/group' },
  ungroupQnaQuestion: { method: 'post', path: '/{rfxId}/qna/items/{qnaItemId}/ungroup-question' },
} as const
